export default __webpack_public_path__ + "static/media/hero.255d740b.svg";